<div style="overflow: scroll;">
	<cdk-table-component
		[displayColumns]="displayColumns"
		[entities]="tableEntities"
		[dataSource]="dataSource"
		(rowClickAction)="viewClass($event)"
	></cdk-table-component>
</div>
